import React from 'react';
import styled from 'styled-components';
import { IEntityCategoryFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import Category from '../Category';
import KubitTooltip from '../../KubitTooltip';

interface IProps {
  entityCategories: IEntityCategoryFieldsFragment[];
  onClick?: () => void;
  disabled?: boolean;
  isManaged?: boolean;
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 8px;
  row-gap: 4px;
`;

const EntityCategoriesList = ({
  entityCategories,
  onClick,
  disabled,
  isManaged,
}: IProps) => {
  if (!entityCategories.length && !isManaged) {
    if (disabled) {
      return <div />;
    }

    return null;
  }

  return (
    <Container>
      {isManaged && (
        <Category disabled={disabled} onClick={onClick} isManaged={isManaged}>
          Managed
        </Category>
      )}
      {entityCategories.map(({ id, name }) => (
        <KubitTooltip key={`tag-label-${id}`} content={name}>
          <Category disabled={disabled} onClick={onClick}>
            {name}
          </Category>
        </KubitTooltip>
      ))}
    </Container>
  );
};

export default EntityCategoriesList;
